import { db } from "../firebase.config"; 
import { collection, query, where, getDocs } from "firebase/firestore";

// LocalStorage utilities for email and user name
// Function to set user email in localStorage
export const setUserEmail = (email) => {
  localStorage.setItem("userEmail", email);
};

// Function to get user email from localStorage
export const getUserEmail = () => {
  return localStorage.getItem("userEmail");
};

// Function to remove user email from localStorage
export const clearUserEmail = () => {
  localStorage.removeItem("userEmail");
};

// Function to set user name in localStorage
export const setUserName = (name) => {
  localStorage.setItem("userName", name);
};

// Function to get user name from localStorage
export const getUserName = () => {
  return localStorage.getItem("userName");
};

// Function to remove user name from localStorage
export const clearUserName = () => {
  localStorage.removeItem("userName");
};

// Function to set sign-in time in localStorage
export const setSignInTime = (time) => {
  localStorage.setItem("SignInTime", time);
};

// Function to get sign-in time from localStorage
export const getSignInTime = () => {
  return localStorage.getItem("SignInTime");
};

// Function to remove sign-in time from localStorage
export const clearSignInTime = () => {
  localStorage.removeItem("SignInTime");
};

// Check if user is an admin - Updated to check both collections
export const setIsAdmin = async (email) => {
  try {
    console.log("Checking admin status for email:", email);
    
    // First, try to check UserProfileMaster collection (used in your user management)
    let querySnapshot = await getDocs(
      query(collection(db, "UserProfileMaster"), where("email", "==", email))
    );

    let isAdmin = false;

    if (!querySnapshot.empty) {
      const userDoc = querySnapshot.docs[0].data();
      console.log("Found user in UserProfileMaster:", userDoc);
      
      // Check if role is AppAdmin or if there's an isAdmin field
      if (userDoc.role === "AppAdmin" || userDoc.isAdmin === true) {
        isAdmin = true;
      }
    } else {
      // Fallback: Check the Users collection (your original logic)
      console.log("User not found in UserProfileMaster, checking Users collection");
      querySnapshot = await getDocs(
        query(collection(db, "UserProfileMaster"), where("userEmail", "==", email))
      );

      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0].data();
        console.log("Found user in Users collection:", userDoc);
        isAdmin = userDoc.isAdmin === true;
      }
    }

    console.log("Final isAdmin status:", isAdmin);
    localStorage.setItem("IsAdmin", JSON.stringify(isAdmin));
    return isAdmin;
    
  } catch (error) {
    console.error("Error checking admin status: ", error);
    localStorage.setItem("IsAdmin", "false");
    return false;
  }
};

// Function to get admin status from localStorage
export const getIsAdmin = () => {
  const isAdmin = localStorage.getItem("IsAdmin");
  console.log("getIsAdmin - raw value:", isAdmin, "type:", typeof isAdmin);
  
  // Handle different possible values
  if (isAdmin === "true" || isAdmin === true) {
    return true;
  }
  if (isAdmin === "false" || isAdmin === false || isAdmin === null) {
    return false;
  }
  
  // Try to parse as JSON in case it was stored as JSON
  try {
    const parsed = JSON.parse(isAdmin);
    return parsed === true;
  } catch {
    return false;
  }
};

// Function to remove admin status from localStorage
export const clearIsAdmin = () => {
  localStorage.removeItem("IsAdmin");
};

// Functions for userId
// Function to set user ID in localStorage
export const setUserId = (userId) => {
  localStorage.setItem("userId", userId);
};

// Function to get user ID from localStorage
export const getUserId = () => {
  return localStorage.getItem("userId");
};

// Function to remove user ID from localStorage
export const clearUserId = () => {
  localStorage.removeItem("userId");
};

// Helper function to manually set admin status for testing
export const setAdminStatusManually = (isAdmin) => {
  localStorage.setItem("IsAdmin", JSON.stringify(isAdmin));
  console.log("Manually set admin status to:", isAdmin);
};